import React, { useState, useMemo } from "react";
import {
  EditorState,
  ContentState,
  convertToRaw,
  convertFromRaw,
  EditorBlock,
} from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
// import 'draft-js/dist/Draft.css';
import "./../styles/RichText.css";
import { useEffect } from "react";
import { Button } from "@mui/material";
import axios from "axios";
import { toast } from "react-toastify";
import Api_Call from "../../ApiCall";

import { useGuidelines } from "../../pages/GuideLinesProvider";
// function RichTextBox(props) {
function convertNewlines(jsonObj) {
  // Deep clone the object to avoid modifying the original
  let convertedObj = JSON.parse(JSON.stringify(jsonObj));

  // Iterate through each property in the object
  for (let key in convertedObj) {
    if (convertedObj.hasOwnProperty(key)) {
      // Check if the property value is a string
      if (typeof convertedObj[key] === "string") {
        // Replace \n with actual newline character
        convertedObj[key] = convertedObj[key].replace(/\\n/g, "\n");
      }
    }
  }

  return convertedObj;
}
const RichTextBox = (props) => {
  // console.log('text from db ', props.children[1]);
  const [editorState, setEditorState] = useState();
  const [editorState1, setEditorState1] = useState();
  // const plainText = props.children[1];
  // const content = ContentState.createFromText(plainText);
  // const [editorState, setEditorState] = useState(() => EditorState.createWithContent(content),);
  const [valuefromEditor, setValueFromEditor] = useState("");
  const [dataToUpdate, setDataToUpdate] = useState("");
  const [hanger, setHanger] = useState();
  const [taskID, setTaskId] = useState(sessionStorage.getItem("ActiveTaskID"));
  console.log(props);
  // const { filteredGuidelines:text, setFilteredGuidelines:setText} = useGuidelines();
  // console.log(dataToUpdate);

  //  console.log(`------------------Rich Text Running ${props.type}  ${props.text}-----------------------------`)
  const memoizedText = useMemo(() => props.text, [props.text]);

  useEffect(() => {
    // setHanger(props.children[5]);  //commented fo genAI
    // setTaskId(props.children[7]);

    setHanger(props.hanger);

    // const plainText = props.children[1];
    // const plainText = props?.text;
    // const plainText = `{${props.text.slice(1, -1)}`;
    const plainText = props.text?.replace(/(\r\n|\n|\r)/gm, "\\n");

    console.log(plainText);
    // console.log(JSON.parse(props.text));

    // console.log(editorState)

    const plainText1 = props?.text;

    // console.log(plainText)
    // console.log(plainText1)
    if (plainText === "" || plainText == undefined) {
      //const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
      const state = EditorState.createEmpty();
      setEditorState(state);
    } else {
      const parsedText = JSON.parse(plainText);
      console.log(parsedText);
      const rawState = {
        blocks: parsedText.blocks,
        entityMap: parsedText.entityMap || {},
      };
      const content = convertFromRaw(rawState);

      console.log(content);

      if (plainText) {
        // const content = convertFromRaw(JSON.parse(plainText));
        // const state = EditorState.createWithContent(content);
        // // props.setText(plainText)
        // setEditorState(state);
        // const content1=convertFromRaw(JSON.parse(plainText1))
        // console.log(content1)
        // const state1 = EditorState.createWithContent(content);
        // console.log(state1)
        // setEditorState1(state1)
        // props.setText(state)
      }

      // const [editorState, setEditorState] = useState(() => EditorState.createWithContent(content),);

      const state = EditorState.createWithContent(content);
      // props.setText(state)
      setEditorState(state);
    }
    // updateClinicalValue()
    setDataToUpdate(props.text);
    // const content = ContentState.createFromText(plainText);
    // const state = EditorState.createWithContent(content);
    // setEditorState(state);
  }, [memoizedText]);

  async function create_data(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      // If error occurs, reject the promise
      reader.onerror = reject;
      // Define an onload handler that's called when file loaded
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(blob);
    });
  }

  const updateClinicalValue = async (data, hanger) => {
    if (editorState) {
      const jsondata = JSON.stringify(
        convertToRaw(editorState.getCurrentContent())
      );

      // console.log('editor state ', jsondata);
      //commented for sending the editor state as is to backend
      // console.log('value of editorState ', editorState.getCurrentContent().getPlainText());
      // const editor_data = editorState.getCurrentContent().getPlainText();
      // let blob = new Blob([editor_data], { type : 'plain/text' });
      // const base64String = await create_data(blob);
      // var new_base64 = base64String.split(",")[1];
      //setDataToUpdate(new_base64);
      // console.log(jsondata)
      // props.setText(jsondata)
      props.setText(jsondata);
      //  setDataToUpdate(jsondata);
      //  console.log(props.text)
      // console.log(props.text==jsondata)

      setDataToUpdate(props.text);
    }
    // setDataToUpdate(jsondata1);
  };

  const callUpdateClinicalDataAPI = async (data, hanger) => {
    // updateClinicalValue()
    //const url = "https://tokcfhkksh.execute-api.us-east-1.amazonaws.com/Dev/vcare_clinicaldataupdate";
    const url =
      "https://63japqerd7.execute-api.us-east-1.amazonaws.com/Dev/zone2_vcare_clinicaldataupdate";
    console.log("hanger in update ", hanger);
    console.log("value to be sent ", dataToUpdate);
    console.log("task ID ", taskID);
    if (dataToUpdate === "") {
      toast.success("Data remains unchanged", { autoClose: true });
    } else {
      try {
        const api = new Api_Call();
        const data = await api.putData("CLINICAL-REVIEW/UPDATE-DATA", {
          taskID: taskID,
          hanger: hanger,
          clinical_data: dataToUpdate,
        });
        let isStatus = data.headers.success;
        console.log(isStatus);
        if (isStatus === true) {
          toast.success(data.body, { autoClose: true });
        } else {
          toast.error(data.body, { autoClose: true });
        }
      } catch (error) {
        console.log(error);
      }

      // axios
      //   .post( url,
      //       { taskID: taskID, hanger: hanger, clinical_data: dataToUpdate }
      //   )
      //   .then(response => {
      //       console.log(response);
      //       let isStatus = response.data.headers.success;
      //       console.log(isStatus);
      //       if (isStatus === true) {
      //           toast.success(response.data.body, { autoClose: true });
      //       } else {
      //           toast.error(response.data.body, { autoClose: true });
      //       }
      //   })
      //       .catch(error => {
      //       console.log(error);
      //   });
    }
  };

  // const syncText=()=>{
  //   if()
  // }

  return (
    <div className="App" style={{ width: "-webkit-fill-available" }}>
      {/* <div style={{textAlign: "right"}}> */}

      {props.isOpen && (
        <div style={{ textAlign: "right" }}>
          <button
            buttonStyle="btn btn--primary btn--outline"
            className="btn btn--primary"
            style={{
              position: "absolute",
              top: "6px",
              right: "40px",
              cursor: "pointer",
              //fontSize: '20px',

              padding: "5px 14px",
              //background: 'transparent',
              // backgroundColor: '#FB4E0B',
              border: "2px solid #ccc",
              // , padding: '1px 2px'
            }}
            onClick={(e) => {
              callUpdateClinicalDataAPI(e, hanger);
              //  updateClinicalValue()
              // console.log("state of modal",props.isOpen);
              if (props.isOpen) {
                // If isOpen is true, call onClose
                props.onClose();
              }
            }}
          >
            Save
          </button>
        </div>
      )}

      {/* </div> */}
      <Editor
        toolbarClassName="toolbarClassName"
        wrapperClassName="wrapperClassName"
        editorClassName="editorClassName"
        editorState={editorState}
        // editorState={editorState1}
        onEditorStateChange={setEditorState}
        // onEditorStateChange={setEditorState1}

        onBlur={updateClinicalValue}
        editorStyle={{
          height: props.isOpen ? "500px" : "",
          border: "1px solid #ddd",
          paddingBottom: "10px",
          width: "100%",

          //  whiteSpace: 'pre-line !important',
        }}
        // , border: '1px solid #ddd'
        // onEditorStateChange={onEditorStateChange}
        toolbar={{
          options: ["inline", "blockType", "list", "textAlign"],
          inline: {
            inDropdown: false,
            options: ["bold", "italic", "underline", "strikethrough"],
          },
          list: { inDropdown: false, options: ["unordered", "ordered"] },
          textAlign: { inDropdown: false },
        }}
      />
      {/* </div> */}
      {!props.isOpen && (
        <div style={{ textAlign: "right" }}>
          {props.children[3] != 7 &&
          props.children[3] != 8 &&
          props.children[3] != 9 ? (
            <>
              {/* <Button
        
          onClick={(e) => {
            callUpdateClinicalDataAPI(e, hanger)
            console.log("state of modal",props.isOpen);
            if (props.isOpen) {
              // If isOpen is true, call onClose
              props.onClose();
            }
          
          }}
        >
        Save
      </Button> 
      <Button buttonStyle="btn--outline" type="reset" >
        Revert
      </Button>  */}
            </>
          ) : (
            ""
          )}
        </div>
      )}
    </div>
  );
};

export default RichTextBox;
